import { render, staticRenderFns } from "./micropolicy-list.vue?vue&type=template&id=494da441&scoped=true&"
import script from "./micropolicy-list.vue?vue&type=script&lang=js&"
export * from "./micropolicy-list.vue?vue&type=script&lang=js&"
import style0 from "./micropolicy-list.vue?vue&type=style&index=0&id=494da441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494da441",
  null
  
)

export default component.exports